import AOS from 'aos';
import isIE from '../utils/isIE';
import { Component } from '../core/component';

export class AnimateOnScroll extends Component {
    constructor() {
        super();
        this.selector = '[data-aos]';
    }

    init() {
        if (isIE()) { return; }

        AOS.init({
            delay: 0,
            duration: 700,
            easing: 'ease',
        });
    }
}
